import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SpuFormWrapperComponent } from '../../components/spu-form-wrapper/spu-form-wrapper.component';
import {
  SpuFormConfig,
  SPU_HEADER_ACTIONS,
  PACKAGE_SPU_PROPERTY_TABLE_SECTION,
  createSpuFormFields,
} from '../../spu.config';

@Component({
  selector: 'app-package-spu-view',
  standalone: true,
  imports: [SpuFormWrapperComponent],
  templateUrl: './package-spu-view.component.html',
  styleUrls: ['./package-spu-view.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PackageSpuViewComponent {
  private readonly translateService = inject(TranslateService);

  config: SpuFormConfig = {
    title: this.translateService.instant(
      'goods.spu.form.titles.view_package_product',
    ),
    formFields: createSpuFormFields(true, this.translateService), // true = package
    tableSections: [PACKAGE_SPU_PROPERTY_TABLE_SECTION],
    headerActions: SPU_HEADER_ACTIONS,
    listRoute: '/goods/spu/package',
    spuType: 'package',
  };
}
